import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UrlEncoderDecoder.module.css';

const UrlEncoderDecoder: React.FC = () => {
  const { t } = useTranslation();
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<'success' | 'error'>('success');

  const showMessage = (text: string, type: 'success' | 'error' = 'success') => {
    setMessage(text);
    setMessageType(type);
    setTimeout(() => {
      setMessage('');
    }, 2500);
  };

  const handleEncode = () => {
    if (!input.trim()) {
      showMessage(t('urlEncoderDecoder.messageInputEncodeRequired'), 'error');
      return;
    }

    try {
      setOutput(encodeURIComponent(input));
    } catch (error) {
      showMessage(t('urlEncoderDecoder.messageEncodeFailed'), 'error');
    }
  };

  const handleDecode = () => {
    if (!input.trim()) {
      showMessage(t('urlEncoderDecoder.messageInputDecodeRequired'), 'error');
      return;
    }

    try {
      setOutput(decodeURIComponent(input));
    } catch (error) {
      showMessage(t('urlEncoderDecoder.messageDecodeFailed'), 'error');
    }
  };

  const handleClear = () => {
    setInput('');
    setOutput('');
  };

  const handleCopy = async () => {
    if (!output) {
      showMessage(t('urlEncoderDecoder.messageNoResultToCopy'), 'error');
      return;
    }

    try {
      await navigator.clipboard.writeText(output);
      showMessage(t('urlEncoderDecoder.messageCopySuccess'));
    } catch (error) {
      showMessage(t('urlEncoderDecoder.messageCopyFailed'), 'error');
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>{t('urlEncoderDecoder.title')}</h2>
        <p className={styles.description}>{t('urlEncoderDecoder.description')}</p>

        {message && (
          <div className={`${styles.message} ${messageType === 'success' ? styles.success : styles.error}`}>
            {message}
          </div>
        )}

        <div className={styles.section}>
          <label className={styles.label} htmlFor="url-input">
            {t('urlEncoderDecoder.inputLabel')}
          </label>
          <textarea
            id="url-input"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder={t('urlEncoderDecoder.inputPlaceholder')}
            className={styles.textarea}
          />
        </div>

        <div className={styles.actions}>
          <button onClick={handleEncode} className={styles.primaryButton}>
            {t('urlEncoderDecoder.encodeButton')}
          </button>
          <button onClick={handleDecode} className={styles.primaryButton}>
            {t('urlEncoderDecoder.decodeButton')}
          </button>
          <button onClick={handleClear} className={styles.secondaryButton}>
            {t('urlEncoderDecoder.clearButton')}
          </button>
        </div>

        <div className={styles.section}>
          <div className={styles.resultHeader}>
            <span className={styles.label}>{t('urlEncoderDecoder.outputHeader')}</span>
            <button onClick={handleCopy} className={styles.copyButton}>
              {t('urlEncoderDecoder.copyButton')}
            </button>
          </div>
          <textarea
            value={output}
            readOnly
            placeholder={t('urlEncoderDecoder.outputPlaceholder')}
            className={`${styles.textarea} ${styles.resultArea}`}
          />
        </div>
      </div>
    </div>
  );
};

export default UrlEncoderDecoder;
